// extracted by mini-css-extract-plugin
export default {"navbar":"_3wObTFa4Z902OR5Stc2TTj","identity":"_2lViUoco_v0WM1DXWKRPsl","avatar":"_3HHhmgi2necLQTAhNoq0Uz"};